import {Component, EventEmitter, Input, Output} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import {RadioItem} from '../../classes/radio-item.class';

@Component({
  selector: 'app-form-radio',
  templateUrl: './form-radio.component.html',
  styleUrls: []
})
export class FormRadioComponent {

  @Input() id = '';
  @Input() label = '';
  @Input() form: UntypedFormGroup;
  @Input() errorMessage = '';
  @Input() isSubmitted = false;
  @Input() radioItems: RadioItem[] = [];

  @Output() change = new EventEmitter();

  get control() {
    return this.form.get(this.id);
  }

  isInvalid(): boolean {
    return this.isSubmitted && (this.control.invalid && this.control.touched);
  }

  onChange(value): void {
    this.change.emit(value);
  }
}
